module.exports = __webpack_public_path__ + "img/welfare-fuli.f24ca091.png";